export default "__VITE_ASSET__Mi6qtzup__"